import { AfterViewInit, Component, EventEmitter, Output } from '@angular/core';
import { NgbAccordionModule, NgbCarouselModule, NgbDropdownModule, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FeatherModule } from "angular-feather";
import { NgScrollbarModule } from "ngx-scrollbar";
import { CommonModule } from "@angular/common";
import { LoginService } from "../../authentication/services/login.service";
import { ROUTES } from "../vertical-sidebar/vertical-menu-items";
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-module-header',
  templateUrl: './module-header.component.html',
  standalone: true,
  imports: [NgbDropdownModule, FeatherModule, NgScrollbarModule,
    CommonModule, NgbAccordionModule, NgbCarouselModule, RouterLink],
  providers: [LoginService],

})
export class ModuleHeaderComponent implements AfterViewInit {
  @Output() toggleSidebar = new EventEmitter<void>();

  menuAdmin = [];
  notifications = [];
  mymessages = [];
  isSuperAdmin: boolean = false;
  user: any;

  constructor(private modalService: NgbModal, private login: LoginService) {
    this.userCredentials();
    this.initializeMenu();

    this.isSuperAdmin = this.login.getIsSuperAdmin();
    ////console.log('this.isSuperAdmin', this.isSuperAdmin);

  }
  ngAfterViewInit() {


  }
  userCredentials() {
    this.user = this.login.getUserInfo();
    ////console.log('user', this.user);
  }

  async initializeMenu() {
    try {

      // Obtener y parsear el menú desde localStorage
      const storedMenuAdmin: any = this.login.getMenuAdmin() || [];
      ////console.log('storedMenuAdmin', storedMenuAdmin);
      const menuAdminArray = storedMenuAdmin.map(item => ({
        ...item,
        btn: 'btn-info',
        permission: true,
        path: `/administration/${item.path}`
      }));
      // if (!menuAdminArray.some(item => item.path === '/administration/causals')) {
      //   menuAdminArray.push({
      //     name: 'Crear Causales',
      //     icon: 'fas fa-list-check',
      //     btn: 'btn-warning',
      //     permission: true,
      //     path: '/administration/causals'
      //   });
      // }
      ////console.log('menuAdminArray procesado:', menuAdminArray);
      this.menuAdmin = menuAdminArray;
    } catch (error) {
      console.error('Error al inicializar el menú:', error);
    }
  }



  logout() {
    this.login.logout();
  }
}
